import { FC } from 'react';
import Typography from '@navi/web-ui/lib/primitives/Typography/Typography';
import { CALL_STATUS_LABELS, TEAM_LABELS } from '../constant';
import { DateFormat, getFormatDate, utcToIST } from '@cp/src/utils/DateHelper';
import { CallSummary } from '../../interface';

interface CallSummarySectionProps {
  callSummary?: CallSummary;
}

const formatTeam = (team?: string) => {
  if (!team) return null;
  return TEAM_LABELS[team] || team;
};

const formatCallDateTime = (callDateTime?: string) => {
  if (!callDateTime) return null;
  const istDate = utcToIST(new Date(callDateTime));
  return getFormatDate(istDate, DateFormat.DD_MMM_YYYY__hh_mm_a);
};

const CallSummarySection: FC<CallSummarySectionProps> = ({ callSummary }) => {
  const hasCallSummaryData = callSummary?.callDateTime || callSummary?.team || callSummary?.method;

  if (!hasCallSummaryData) return null;

  const callSummaryFields = [
    {
      key: 'callDateTime',
      label: 'Call Date & Time',
      format: (v: string) => formatCallDateTime(v)
    },
    {
      key: 'method',
      label: 'Method',
      format: (v: string) => CALL_STATUS_LABELS[v] || v
    },
    { key: 'team', label: 'Team', format: formatTeam }
  ] as const;

  return (
    <div className="px-4 py-3 grid grid-cols-2 gap-y-3 gap-x-8 border-t border-[var(--grayscale-6)]">
      {callSummaryFields.map(({ key, label, format }) => {
        const value = callSummary?.[key];
        if (!value) return null;
        return (
          <div key={key} className="flex flex-col">
            <Typography variant="p5" color="var(--grayscale-3)">
              {label}
            </Typography>
            <Typography variant="p5" color="var(--grayscale-1)">
              {format(value)}
            </Typography>
          </div>
        );
      })}
    </div>
  );
};

export default CallSummarySection;
